import * as React from 'react';
import { useDispatch } from 'react-redux';
import {
  CSVUploadInstructions,
  fetchApi,
  FileData,
  FormButtons,
  getRowsFromRawString,
  identifyErrors,
  makeResetCache,
  notifyError,
  notifyResponse,
  PageTitle,
  ReportUploadStatus,
  Section,
} from 'gossamer-front-end';
import { CSVRow } from 'gossamer-unified';
import { MemberUpload, MemberUploadRow, memberValidator, UserView } from 'cb-model';

export const BulkUploadMembers = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const [rows, setRows] = React.useState<CSVRow<MemberUploadRow>[] | null>(null);
  const [errors, setErrors] = React.useState<string[][] | null>(null);
  const [submitting, setSubmitting] = React.useState(false);
  const resetCache = makeResetCache(dispatch);

  const handleChange = (newValue: string) => {
    try {
      const rows = getRowsFromRawString(MemberUpload, newValue);
      setRows(rows);
      setErrors(identifyErrors(rows, memberValidator));
    } catch (e) {
      setRows(null);
      setErrors(null);
      notifyError(e, 'An error occurred while reading the CSV file');
    }
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const members = errors
        .map((error) => error.length === 0)
        .map((valid, index) => (valid ? rows[index] : null))
        .filter((row) => !!row);
      const response = await fetchApi('POST', `/main/institution-member-bulk-upload`, {
        members,
      });
      setRows([]);
      setErrors([]);
      resetCache(UserView.id);
      notifyResponse(response);
    } catch (e) {
      notifyError(e, 'An error occurred while adding members to the group');
    }
    setSubmitting(false);
  };

  return (
    <>
      <PageTitle title="Bulk Upload Members" subtitle="Using a CSV file as described below" />

      <Section>
        <CSVUploadInstructions entity={MemberUpload} />
        <div className="mb20px"></div>
        <div>
          Choose a CSV file:&nbsp;
          <FileData onChange={handleChange} />
        </div>
      </Section>

      <Section>
        {!!rows && (
          <div>
            <ReportUploadStatus errors={errors} />
            <FormButtons handleSubmit={handleSubmit} submitting={submitting} />
          </div>
        )}
      </Section>
    </>
  );
};
